import { eApplicationActions } from '../eApplicationActions';
import { DispatchApplicationAction } from '../DispatchApplicationAction';
import { executePartiesActions } from '../../../../store/order/orderData/partiesActionsSlice';
import { ThunkDispatch } from 'redux-thunk';
import { UUID } from '../../../../types/shared/UUID';
import { IParty } from '../../../../ui-toolkit/orders/interfaces/IParty';

export interface ISavePartyAsyncSetup {
  orderId: UUID;
  isPartyNew: boolean;
  dispatch: DispatchApplicationAction;
  dispatchRedux: ThunkDispatch<any, any, any>;
  hasExtraSuccessWarning: boolean;
  onSuccess: () => void;
}

export interface ISavePartyAsyncProps {
  party: IParty;
}

export const savePartyAsync =
  ({ isPartyNew, orderId, dispatch, dispatchRedux, hasExtraSuccessWarning, onSuccess }: ISavePartyAsyncSetup) =>
  async ({ party }: ISavePartyAsyncProps) => {
    const verb = isPartyNew ? 'added' : 'updated';
    const { id, ...newParty } = party;
    const actionToDo = dispatchRedux(
      executePartiesActions({
        orderId,
        parties: {
          deleteParties: [],
          createParties: isPartyNew ? [newParty] : [],
          updateParties: !isPartyNew ? [party] : [],
        },
      })
    );
    try {
      dispatch({
        type: eApplicationActions.ChangePartyModalMessage,
        payload: { verb, updating: true, updated: false, error: '', hasExtraSuccessWarning },
      });
      await actionToDo;
      dispatch({
        type: eApplicationActions.ChangePartyModalMessage,
        payload: { verb, updating: false, updated: true, error: '', hasExtraSuccessWarning },
      });
      onSuccess();
    } catch (error: any) {
      dispatch({
        type: eApplicationActions.ChangePartyModalMessage,
        payload: { verb, updating: false, updated: true, error, hasExtraSuccessWarning },
      });
    }
  };
